import * as React from 'react';

import { useApplicationContext } from '../../utils/applicationContext';
import { sendUXSEvent } from '../../utils/uxs';

interface ISearchStringUsedData {
  expiresAt: number;
}

export function useSearchStringUxfeedbackCampaign() {
  const { logger, config } = useApplicationContext();

  const searchStringKey = config.get<string>('uxfeedback.searchString.localStorageKey') || 'searchStringUsed';
  const campaignName = config.get<string>('uxfeedback.savedSearches.desktopCampanyName') || 'AudMonSearchDesktop';

  React.useEffect(() => {
    const currentTime = Date.now();
    let timeoutId: number | undefined;

    try {
      const searchStringUsedDataJson = localStorage.getItem(searchStringKey);

      if (searchStringUsedDataJson) {
        const searchStringUsedData: ISearchStringUsedData = JSON.parse(searchStringUsedDataJson);

        if (typeof searchStringUsedData.expiresAt === 'number' && searchStringUsedData.expiresAt >= currentTime) {
          timeoutId = window.setTimeout(() => {
            sendUXSEvent(campaignName);
          }, 3000);
        }
      }
    } catch (error) {
      logger.warning('Failed to show uxfeedback search string campaign', error);
    }

    return () => {
      if (timeoutId !== undefined) {
        window.clearTimeout(timeoutId);
      }
    };
  }, [searchStringKey, campaignName, logger]);
}
